import { create } from "zustand";

interface TrackingContextState {
  source: string | null;
  pointsConsumed: number | null;
  amountJpy: number | null;
  setSource: (source: string | null) => void;
  setPointsConsumed: (points: number | null) => void;
  setAmountJpy: (amount: number | null) => void;
  clear: () => void;
}

/**
 * Reproイベントに付与するコンテキスト（遷移起点・消費ポイント・購入円額）を保持するストア。
 * trackEvent 呼び出し時にイベント設定（eventTrackingConfig）に応じて参照・クリアされる。
 */
export const useTrackingContextStore = create<TrackingContextState>()(
  (set) => ({
    source: null,
    pointsConsumed: null,
    amountJpy: null,
    setSource: (source) => set({ source }),
    setPointsConsumed: (points) => set({ pointsConsumed: points }),
    setAmountJpy: (amount) => set({ amountJpy: amount }),
    clear: () => set({ source: null, pointsConsumed: null, amountJpy: null }),
  }),
);
